// Navbar.jsx
import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/img/logo_full small.png";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const dropdownRef = useRef(null);

  // ✅ Scroll to top on any nav click
  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  // ✅ Close menus + scroll to top
  const closeAll = () => {
    setIsOpen(false);
    setAboutOpen(false);
    scrollToTop();
  };

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
    setAboutOpen(false);
  };

  const toggleAbout = (e) => {
    e.preventDefault();
    setAboutOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setAboutOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const navClass = ({ isActive }) => (isActive ? "active" : "");

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" onClick={closeAll} className="logo-link" aria-label="Home">
          <img src={logo} alt="MedTech Logo" className="logo-img" />
        </Link>

        {/* Hamburger */}
        <button
          className={`hamburger ${isOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={isOpen}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>

        {/* Navigation */}
        <ul className={`nav-links ${isOpen ? "open" : ""}`}>
          <li>
            <NavLink to="/" className={navClass} onClick={closeAll}>
              Home
            </NavLink>
          </li>

          <li>
            <NavLink to="/Addpages" className={navClass} onClick={closeAll}>
              Our Technology
            </NavLink>
          </li>

          <li>
            <NavLink to="/partners" className={navClass} onClick={closeAll}>
              Our Partners
            </NavLink>
          </li>

          <li>
            <NavLink to="/investors" className={navClass} onClick={closeAll}>
              For Investors
            </NavLink>
          </li>

          {/* About Dropdown */}
          <li className={`dropdown ${aboutOpen ? "show" : ""}`} ref={dropdownRef}>
            <NavLink
              to="/about"
              className={`dropdown-toggle ${
                window.location.pathname === "/about" ? "active" : ""
              }`}
              onClick={(e) => {
                e.preventDefault(); // ✅ stop navigation (only toggle dropdown)
                toggleAbout(e); // ✅ open/close dropdown
              }}
            >
              About <span className="caret">▾</span>
            </NavLink>

            <ul className="dropdown-menu">
              <li>
                <NavLink to="/about" className={navClass} onClick={closeAll}>
                  About Us
                </NavLink>
              </li>
              <li>
                <NavLink to="/founders" className={navClass} onClick={closeAll}>
                  Founders
                </NavLink>
              </li>
              <li>
                <NavLink to="/Career" className={navClass} onClick={closeAll}>
                  Careers
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/collaborations"
                  className={navClass}
                  onClick={closeAll}
                >
                  Collaborations
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/achievements"
                  className={navClass}
                  onClick={closeAll}
                >
                  Achievements
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/feebback"
                  className={navClass}
                  onClick={closeAll}
                >
                 Feeback form
                </NavLink>
              </li>
            </ul>
          </li>

          <li>
            <NavLink to="/products" className={navClass} onClick={closeAll}>
              Products
            </NavLink>
          </li>
               <li>
            <NavLink to="/event" className={navClass} onClick={closeAll}>
             Event
            </NavLink>
          </li>
          <li>
            <NavLink to="/news" className={navClass} onClick={closeAll}>
              News
            </NavLink>
          </li>

          <li>
            <NavLink to="/contact" className={navClass} onClick={closeAll}>
              Contact
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
}
